import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import "./styles/designTokens.css";
import "./index.css";
// After index.css (which emits Tailwind utilities) so responsive/motion rules can win
// same-specificity conflicts. PROD-UX-077 / FULL-0163.
import "./styles/responsive.css";
import App from "./App";
import { createQueryClient } from "./queryClient";

// Set a random favicon once on page load
const _favicons = ["/logo.png", "/logo1.png", "/logo2.png", "/logo3.png", "/logo4.png", "/logo5.png", "/logo6.png"];
const _link = document.querySelector("link[rel*='icon']") || document.createElement("link");
_link.type = "image/png";
_link.rel  = "shortcut icon";
_link.href = _favicons[Math.floor(Math.random() * _favicons.length)];
document.head.appendChild(_link);

const queryClient = createQueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
